module.exports = __webpack_public_path__ + "prod/1.42.2/img/footerone.96fdef7e.png";